import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { Explicit, Note, Print, ListAlt } from '@material-ui/icons';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import tableIcons from '../../utils/editTableIcons';
import { monthToString } from '../../utils/monthMap';
import moment from "moment";

import PickupOrder from '../../models/PickupOrderGha';

import { baseUrl } from '../../api/baseUrl';

import style from './awbInfo.module.css';
import commonStyles from '../common/common.module.css';
import Awb from '../../models/Awb';
import AwbDetails from '../../models/AwbDetails';

const iconFontSize = 20;

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    materialIconR4C: {
      color: 'white', 
      margin: '0', 
      cursor: 'pointer', 
      padding: '0 4px', 
      fontSize: '10px', 
      borderRadius: '3px', 
      backgroundColor: '#000', 
    },
    textButton: {
      cursor: 'pointer',
      color: 'inherit',
      textDecoration: 'underline'
    }
  });

interface OrderInfoComponentProps {
  classes: any;
  pickupOrders: Array<PickupOrder>;
  awbCode: string;
  awbNumber: string;
  handleOpenModal:(type: string,  orderNumber: string) =>  void;
  handleOpenAwbReportModal: (orderNumber: string, orderType: string) => void;
  printOrder: (orderNumber: string) => void;
  // TODO: Add history prop or similar to navigate
  history?: any; 
  offlineRfs?: Array<any>;
  awb: Awb;
};

const orderInfoComponent = (props: OrderInfoComponentProps) => {

  const { classes, offlineRfs } = props;

  const printPdf = (id?: number): void => {
    let url: string = `${baseUrl}offlinerfs_order/${id}/file`;

    window.open(url);
  }

  return (

    <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>

      <h3 className={ `${ commonStyles.header } ` } >Orders Information</h3>

      <div className={ style.inputsWrapper } >

        <MaterialTable
        
          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

          icons={ tableIcons }

          data={ props.pickupOrders }

          columns={[
            { title: '#Order', field: 'number', render: (rowData: PickupOrder) => {
              const isGoRelated = rowData.order_type === 'go';
              const goLabel = isGoRelated ? ' (GO)' : '';
              return (
                <span>{ rowData.return_type ? `${rowData.number} (Ret)` : rowData.number }{goLabel}</span>
              )} 
            },

            { title: 'Pcs', render: (rowData: PickupOrder) => {
                let awb: any = rowData.list.find((x: any) => {
                  return x.code === props.awbCode && x.number === props.awbNumber;
                });
                return (
                  <span>{ awb.pieces }</span>
                )
            }},

            { title: 'Wgt', render: (rowData: PickupOrder) => {
                let awb: any = rowData.list.find((x: any) => {
                  return x.code === props.awbCode && x.number === props.awbNumber;
                });
                return (
                  <span>{ awb.weight }</span>
                )
            }},

            { title: '#Created', render: (rowData: PickupOrder) => {
              // 2020-03-18T14:07:44.694Z
              
              return (
                <span>{moment(rowData.create_date).format('DD-MMM-YYYY HH:mm')}</span>
                )
              }},
              {
                title: 'Scheduled Pickup', render: (rowData: PickupOrder) => {
                  const pickupYear = rowData.pickup_date ? (rowData.pickup_date.substring(0,4)) : '';
                  const pickupMonth = rowData.pickup_date ? (rowData.pickup_date.substring(4,6)) : '';
                  const pickupDay = rowData.pickup_date ? (rowData.pickup_date.substring(6,8)) : '';
                  const pickupTime = rowData.pickup_time?  rowData.pickup_time.substring(0,2) + ':' + rowData.pickup_time.substring(2,4) : '';
                  
                  return (
                  <span>{ rowData.pickup_date ? `${pickupDay} ${monthToString[pickupMonth]} ${pickupYear} ${pickupTime ? pickupTime : ''}` : ''}</span>
                  )
              }},

              { title: 'Driver check in',  render: (rowData: PickupOrder) => {
                const driverCheckIn = rowData.driver_checkin_time?  rowData.driver_checkin_time.substring(0,2) + ':' + rowData.driver_checkin_time.substring(2,4) : '';
                
                return <span>{driverCheckIn}</span>
              }},
            
              { title: 'Driver Check Out', render: (rowData: PickupOrder) => {
                // Find specific AWB in list
                const awb = rowData.list.find((x: any) => {
                  return x.code === props.awbCode && x.number === props.awbNumber;
                });
              
                // Check if AWB is returned
                if (awb && awb.returned) {
                  const returnedYear = awb.returned_awb_date ? (awb.returned_awb_date.substring(0,4)) : '';
                  const returnedMonth = awb.returned_awb_date ? (awb.returned_awb_date.substring(4,6)) : '';
                  const returnedDay = awb.returned_awb_date ? (awb.returned_awb_date.substring(6,8)) : '';
                  const returnedTime = awb.returned_awb_time ? 
                    awb.returned_awb_time.substring(0,2) + ':' + awb.returned_awb_time.substring(2,4) : '';
                  
                  return (
                    <span>{ awb.returned_awb_date ? 
                      `${returnedDay} ${monthToString[returnedMonth]} ${returnedYear} ${returnedTime ? returnedTime : ''}` : 
                      ''}
                    </span>
                  )
                }
              
                // Show delivered date/time if not returned
                const deliveredYear = rowData.delivered_date ? (rowData.delivered_date.substring(0,4)) : '';
                const deliveredMonth = rowData.delivered_date ? (rowData.delivered_date.substring(4,6)) : '';
                const deliveredDay = rowData.delivered_date ? (rowData.delivered_date.substring(6,8)) : '';
                const deliveredTime = rowData.delivered_time ? 
                  rowData.delivered_time.substring(0,2) + ':' + rowData.delivered_time.substring(2,4) : '';
                
                return (
                  <span>{ rowData.delivered_date ? 
                    `${deliveredDay} ${monthToString[deliveredMonth]} ${deliveredYear} ${deliveredTime ? deliveredTime : ''}` : 
                    ''}
                  </span>
                )
              }},
            { title: 'Customer Error',  render: (rowData: PickupOrder) => {
              
              return <span>{rowData.customer_error ? rowData.general_remarks : 'None'}</span>
            }},
            { title: 'Driver Remarks',  render: (rowData: PickupOrder) => {
              
              return <span>{rowData.driverInfo && rowData.driverInfo.remarks ? rowData.driverInfo.remarks : 'None'}</span>
            }},

            {
              title: 'Action', headerStyle: { textAlign: 'center' },
              render: (rowData: PickupOrder) => {
                
                const rfs = offlineRfs && offlineRfs.find((r: any) => r.id_dropoff_order === rowData.id);
                return <span className={`${style.awbActionsList} ${style.awbActionsListGap}`} >
                  {rowData.order_type === 'do' &&
                    <Tooltip title="Open R4C checks">
                      <div><p className={classes.materialIconR4C} onClick={(events) => props.handleOpenModal('rForCheck', rowData.number)} > R4C</p></div>
                    </Tooltip>
                  }
                  <Tooltip title="Open Order Note">
                    <div><p className={classes.materialIconR4C} onClick={(events) => props.handleOpenModal('orderNote', rowData.number)}>ODR</p></div>
                  </Tooltip>

                  <Tooltip title="Open Awb Report">
                    <div><p className={classes.materialIconR4C} onClick={(events) => props.handleOpenAwbReportModal(rowData.number, rowData.order_type ? rowData.order_type : '')}>XCP</p></div>
                  </Tooltip>

                  {rowData.order_type === 'do' &&
                    <Tooltip title="Print">
                        <Print className={ classes.materialIcon } onClick={ () => props.printOrder(rowData.number) } />
                      </Tooltip>
                  }

                  {rowData.order_type === 'do' && (props.awb.screened || (props.awb.export_metadata && props.awb.export_metadata.ccsf)) &&
                    <Tooltip title="Open Screening Page">
                        <Explicit className={ classes.materialIcon } onClick={ () => props.history.push(`/screening/${props.awb.code}/${props.awb.number}/${props.awb.version}/${rowData.number}`) } />
                      </Tooltip>
                  }

                   { rfs &&
                      <Tooltip title={
                        <React.Fragment>
                          <div style={{ fontSize: '12px' }}>Manifest Details</div>
                          <div style={{ fontSize: '10px' }}>Driver: {rfs.driver_name}</div>
                          <div style={{ fontSize: '10px' }}>Plate: {rfs.driver_vehichle_registration}</div>
                          <div style={{ fontSize: '10px' }}>RFS #: {rfs.rfs_number}</div>
                        </React.Fragment>
                      }>
                        <ListAlt className={ classes.materialIcon } onClick={() => printPdf(rfs.id_offline_rfs)}/>
                      </Tooltip>
                   }

                </span>;
              }
            }

          ]}

          options={{
            search: false,
            paging: false,
            showTitle: false,
            actionsColumnIndex: -1,
            toolbar: false,
            sorting: false,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
          }}
        />
        
      </div>

    </div>

  );
};

export default withStyles(styles)(orderInfoComponent);